import "../../styles/HomeNew.css";

const EVENTS = [
  {
    title: "5K Run / Walk",
    emoji: "🏃",
    color: "card--purple",
    chipClass: "lchip--purple",
    badge: "Open",
    detail: "Register by April 18 for a FREE event T-shirt!",
    href: "https://tinyurl.com/Run4FBT",
    cta: "Register Now →",
  },
  {
    title: "5K STEAM Race",
    emoji: "🔬",
    color: "card--pink",
    chipClass: "lchip--pink",
    badge: "Open",
    detail: "Combine running with STEAM challenges along the course.",
    href: "https://tinyurl.com/Run4FBT",
    cta: "Register Now →",
  },
  {
    title: "2K STEAM Race",
    emoji: "🧠",
    color: "card--green",
    chipClass: "lchip--green",
    badge: "Open",
    detail: "A shorter STEAM-powered route — great for younger participants.",
    href: "https://tinyurl.com/Run4FBT",
    cta: "Register Now →",
  },
  {
    title: "2K Run / Walk",
    emoji: "🚶",
    color: "card--purple",
    chipClass: "lchip--purple",
    badge: "Open",
    detail: "Perfect for families, kids, and casual walkers of all ages.",
    href: "https://tinyurl.com/Run4FBT",
    cta: "Register Now →",
  },
];

export default function Run4FBT() {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "50svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr auto" }}>
          <div className="hero__text">
            <p className="hero__kicker">For A Better Tomorrow · Community Run</p>
            <h1 className="hero__h1">
              Run4FBT<br />
              <span className="hero__accent">5K & 2K</span>
            </h1>
            <p className="hero__sub">
              Run with purpose. Move for your community. Every step supports
              youth experiencing homelessness through Project Oz.
            </p>
            <div className="hero__pills">
              <span className="pill pill--purple">🗓 May 2, 2026</span>
              <span className="pill pill--pink">📍 Tipton Park, Bloomington IL</span>
              <span className="pill pill--green">🎽 Free T-shirt by Apr 18</span>
            </div>
            <div className="hero__ctas">
              <a href="https://tinyurl.com/Run4FBT" target="_blank" rel="noopener noreferrer" className="cta cta--solid">Register Now</a>
              <a href="#events" className="cta cta--ghost">View Events ↓</a>
            </div>
          </div>

          {/* Event Details Card */}
          <div className="hero__stats">
            <div className="hstat hstat--purple">
              <span className="hstat__n">5K</span>
              <span className="hstat__l">Run / Walk</span>
            </div>
            <div className="hstat hstat--pink">
              <span className="hstat__n">2K</span>
              <span className="hstat__l">Run / Walk</span>
            </div>
            <div className="hstat hstat--green">
              <span className="hstat__n">STEAM</span>
              <span className="hstat__l">Quest Races</span>
            </div>
            <div className="hstat hstat--soft">
              <span className="hstat__n" style={{ fontSize: "1rem", lineHeight: 1.3 }}>Tipton<br />Park</span>
              <span className="hstat__l">Bloomington, IL</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── EVENT INFO STRIP ── */}
      <section className="local" style={{ maxWidth: "860px", marginInline: "auto", paddingBottom: 0 }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "1rem" }}>
          {[
            { label: "When", value: "Saturday, May 2, 2026", emoji: "📅", bg: "var(--pu-50)", border: "var(--pu-200)", color: "var(--pu-700)" },
            { label: "T-Shirt Deadline", value: "Register by April 18 to receive a FREE event T-shirt!", emoji: "🎽", bg: "var(--pk-50)", border: "var(--pk-200)", color: "var(--pk-700)" },
            { label: "Location", value: "Tipton Park, Bloomington, IL", emoji: "📍", bg: "var(--gn-50)", border: "var(--gn-200)", color: "var(--gn-700)" },
          ].map(item => (
            <div key={item.label} className="lcard" style={{ background: item.bg, borderColor: item.border, gap: ".5rem", alignItems: "flex-start" }}>
              <span style={{ fontSize: "1.4rem" }}>{item.emoji}</span>
              <span className="lcard__chip" style={{ fontSize: ".62rem", background: item.border, color: item.color }}>{item.label}</span>
              <p style={{ fontSize: ".85rem", fontWeight: 600, color: "var(--ink)", lineHeight: 1.5 }}>{item.value}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section className="local" style={{ maxWidth: "860px", marginInline: "auto", paddingTop: "1.5rem" }}>
        <div className="lcard lcard--open" style={{ background: "var(--pu-50)", borderColor: "var(--pu-200)", padding: "1.8rem 2rem" }}>
          <p style={{ fontSize: ".97rem", color: "var(--muted)", lineHeight: 1.85, textAlign: "center", fontStyle: "italic" }}>
            Join us for <strong style={{ color: "var(--pu-700)" }}>Run4FBT – For A Better Tomorrow 5K & 2K Run / Walk + STEAM Quest</strong> and
            help make a difference while enjoying a fun community event with family and friends.
            Every step you take helps support youth experiencing homelessness through{" "}
            <strong style={{ color: "var(--pu-700)" }}>Project Oz</strong>. Your participation directly
            contributes to providing resources, stability, and opportunities for young people in need.
          </p>
        </div>
      </section>

      {/* ── EVENTS ── */}
      <section id="events" className="events" style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Choose Your Challenge</span>
          <h2 className="sec-h2">Events & Races</h2>
          <p className="sec-sub">Fun for families, kids, runners, and walkers — pick your event and run toward a better tomorrow.</p>
        </div>
        <div className="events__grid">
          {EVENTS.map(evt => (
            <div key={evt.title} className={`ecard ${evt.color}`} style={{ cursor: evt.href ? "pointer" : "default" }}>
              <div className="ecard__icon">{evt.emoji}</div>
              <div className="ecard__img" style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                background: evt.color === "card--purple" ? "var(--pu-200)"
                  : evt.color === "card--pink" ? "var(--pk-200)" : "var(--gn-200)",
                fontSize: "4rem",
              }}>
                {evt.emoji}
              </div>
              <span className="ecard__label">{evt.badge}</span>
              <h3 className="ecard__name">{evt.title}</h3>
              <p className="ecard__desc">{evt.detail}</p>
              {evt.href
                ? <a href={evt.href} target="_blank" rel="noopener noreferrer" className="ecard__arrow">{evt.cta}</a>
                : <span className="ecard__arrow" style={{ opacity: .5 }}>{evt.cta}</span>
              }
            </div>
          ))}
        </div>
      </section>

      {/* ── FLYER ── */}
      <section id="flyer" className="local" style={{ maxWidth: "680px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Official Flyer</span>
          <h2 className="sec-h2">Run4FBT 2026</h2>
        </div>
        <div className="lcard lcard--open" style={{ padding: "1.5rem", alignItems: "center" }}>
          <img
            src="/images/flyers/5k.jpg"
            alt="Run4FBT 5K & 2K Flyer"
            style={{ width: "100%", borderRadius: "12px", display: "block", boxShadow: "0 8px 40px rgba(0,0,0,.1)" }}
          />
        </div>
      </section>

      {/* ── REGISTER CTA BAND ── */}
      <section className="local" style={{ maxWidth: "680px", marginInline: "auto", paddingTop: 0 }}>
        <div className="lcard lcard--open" style={{
          background: "var(--pu-50)", borderColor: "var(--pu-200)",
          padding: "1.8rem 2rem", alignItems: "center", gap: "1rem"
        }}>
          <p style={{ fontSize: "1.05rem", fontWeight: 700, color: "var(--pu-700)", textAlign: "center" }}>
            👉 Invite your friends, bring your family, and help us run toward a better tomorrow.
          </p>
          <a
            href="https://tinyurl.com/Run4FBT"
            target="_blank"
            rel="noopener noreferrer"
            className="cta cta--solid"
            style={{ alignSelf: "center" }}
          >
            Register at tinyurl.com/Run4FBT
          </a>
        </div>
      </section>

      {/* ── QUOTE BAND ── */}
      <div className="quote-band">
        <p>"Our mission is to promote social justice by meeting needs in the local community and the world through accountable, sustainable philanthropy and by nurturing future generations of servant leaders."</p>
      </div>

    </div>
  );
}